import LabelOverlay from 'components/Markup/LabelOverlay'

export default {
  label: { Overlay: LabelOverlay, title: 'Label' },
  rectangle: { Overlay: google.maps.Rectangle, title: 'Rectangle' },
  circle: { Overlay: google.maps.Circle, title: 'Circle' },
  polygon: { Overlay: google.maps.Polygon, title: 'Polygon' },
  polyline: { Overlay: google.maps.Polyline, title: 'Polyline' },
  wall: { Overlay: google.maps.Polyline, title: 'Wall' }
}



// WEBPACK FOOTER //
// ./src/components/Markup/mappings.js